import Apiservice from '../../api.service';
import { API_URL } from '../../../../common/config.js'
const apiService = Apiservice;


export default class UserEnrollmentInfoService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/kiosk/user-enrollment-info`;
    }

    paginate(data, index) {
        let url = `${this.#api}`;
        if (data != null && data != undefined && data != "") {
            var queryString = Object.keys(data).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }).join('&');
            url = url + '?' + queryString;
            if (index)
                url = url + "&page=" + index
        } else {
            url = url + "?page=" + index
        }
        return apiService.get(url);
    }
    
    findByQrCode(data) {
        let url = `${this.#api}/search/qr-code/${data}`;
        return apiService.query(url);
    }

    markAsAttended(id){
        let url = `${this.#api}/${id}/mark-as-attended`
        return apiService.post(url);
    }

    markAsNotAttended(id){
        let url = `${this.#api}/${id}/mark-as-not-attended`
        return apiService.post(url);
    }

}